export enum AlertLevel {
  success = "SUCCESS",
  info = "INFO",
  warn = "WARN",
  error = "ERROR",
}
